import { instantCardApi } from 'redux/services/instant-card'
import { InstantCardObject } from 'redux/services/instant-card/types'

import { AppLoader } from 'components/AppLoader'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'

import {
  INSTANT_CARD_REISSUE_TEXT,
  INSTANT_CARD_STATUS_TEXT,
  INSTANT_CARD_TYPE_TEXT,
} from 'constants/instant-card'

import { formatDate } from 'shared/libs'

import styles from './Details.module.scss'

interface DetailsProps {
  id: InstantCardObject['id']
  onClose: () => void
}

export const Details = ({ id, onClose }: DetailsProps) => {
  const { data, isLoading, isSuccess, error } =
    instantCardApi.useGetInstantCardByIdQuery(id)

  function renderValue(label: string, key: keyof InstantCardObject) {
    if (data?.[key]) {
      return (
        <div className={styles.item}>
          <div className={styles.itemName}>{label}</div>
          <div className={styles.itemText}>{data?.[key]}</div>
        </div>
      )
    }
    return null
  }

  if (isLoading) return <AppLoader />

  if (isSuccess) {
    return (
      <>
        <AppModalHeader onClose={onClose} title={data.device_name} />
        <div className={styles.container}>
          {renderValue('UUID', 'device')}
          {renderValue('Наименование', 'device_name')}
          {renderValue('ПАН', 'pan')}
          <div className={styles.item}>
            <div className={styles.itemName}>Дата создания</div>
            <div className={styles.itemText}>{formatDate(data.created_at)}</div>
          </div>
          {renderValue('Руководитель', 'supervisor')}

          <div className={styles.item}>
            <div className={styles.itemName}>Тип карты</div>
            <div className={styles.itemText}>
              {INSTANT_CARD_TYPE_TEXT[data.type]}
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.itemName}>Тип операции</div>
            <div className={styles.itemText}>
              {INSTANT_CARD_REISSUE_TEXT[String(data.reissue)]}
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.itemName}>Статус</div>
            <div className={styles.itemText}>
              {INSTANT_CARD_STATUS_TEXT[data.status]}
            </div>
          </div>
        </div>
      </>
    )
  }

  return <code>{JSON.stringify(error)}</code>
}
